import React, { useState } from 'react';
import AccordionItem from './AccordionItem';

const Accordion = ({items}) => {

  // El primer ítem estará abierto por defecto
  const [openItem, setOpenItem] = useState(0);

  const handleToggle = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <div className="w-full space-y-[1.375rem]">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          isOpen={openItem === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;